/**
 * Internal dependencies.
 */
import edit from './edit';
import metadata from './block.json';
import { TitleIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Section Title' ),
	description: __( 'Gutenify Title.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Section Title' ),
		__( 'Title' ),
		__( 'heading' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save: () => {},
	supports: {
		html: false,
		// align: [ 'center', 'wide', 'full' ],
	},
};

export { name, category, settings };
